import React from "react";
import './divider.css'


const Divider = ({dividerText = ''}) => {
    return <div className="divider">{dividerText}</div>
}

export default Divider;